{
  "title": "My account",
  "subtitle": "Sign-in details: email and password",
  "profile": {
    "title": "Profile",
    "email": "Email",
    "emailHint": "A confirmation code is sent to the new email, and your current email gets a notice after the change."
  },
  "email": {
    "title": "Change email",
    "current": "Current email:",
    "newEmail": "New email",
    "currentPassword": "Current password",
    "currentPasswordHint": "To confirm it's you",
    "passwordRequired": "Enter your current password",
    "invalid": "Enter a valid email",
    "sendCode": "Send code",
    "sending": "Sending…",
    "codeSentSelf": "Enter the 6-digit code sent to {{email}}",
    "codeSentOther": "Ask the account holder for the 6-digit code sent to {{email}} and enter it here",
    "codeLabel": "Confirmation code",
    "validFor": "The code is valid for 10 minutes",
    "wrongCode": "Wrong code. Attempts left: {{n}}",
    "expired": "The code has expired or no attempts are left. Start again.",
    "startOver": "Start again",
    "changeAddress": "Change the address",
    "resend": "Resend code",
    "resendIn": "Resend in {{n}}s",
    "resent": "A new code was sent",
    "changed": "Email changed to {{email}}"
  },
  "password": {
    "title": "Change password",
    "current": "Current password",
    "currentRequired": "Enter your current password",
    "new": "New password",
    "confirm": "Confirm new password",
    "notEmail": "The password must not equal the email",
    "otherDevices": "You'll be signed out on other devices; this one stays signed in.",
    "submit": "Change password",
    "saving": "Saving…",
    "changed": "Password changed; other devices were signed out"
  }
}
